<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات کلی حقوق سال '{{inner_Year}}' برای '{{inner_Person_Fullname}}'</h5>
      <form [formGroup]="AddNewSalary" (submit)="SubmitAddNewSalary()">


        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">حقوق پایه (تمیم)</label>
            <input formControlName="Payeh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Payeh().valid && get_Form_Payeh().touched" class="form-text text-muted MyErrorRedColor">حقوق پایه را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">حق شیفت</label>
            <input formControlName="Shift" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Shift().valid && get_Form_Shift().touched" class="form-text text-muted MyErrorRedColor">حق شیفت را وارد نمائید.</small>
          </div>
        </div>

        <hr/>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">امتیاز تجربه</label>
            <input formControlName="Tajrobeh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Tajrobeh().valid && get_Form_Tajrobeh().touched" class="form-text text-muted MyErrorRedColor">امتیاز تجربه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Kpi</label>
            <input formControlName="Kpi" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Kpi().valid && get_Form_Kpi().touched" class="form-text text-muted MyErrorRedColor">Kpi  را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">ایاب و ذهاب</label>
            <input formControlName="AyabZohab" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_AyabZohab().valid && get_Form_AyabZohab().touched" class="form-text text-muted MyErrorRedColor">ایاب و ذهاب را وارد نمائید.</small>
          </div>

        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSalary.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button (click)="onBack()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>
